//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      value: "",
      notices: [],
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
    }),
  },
  created() {
    this.requestNotices();
  },
  activated: function () {},
  methods: {
    onSearch(value) {
      console.log(value);
    },
    requestNotices() {
      fetch.listMobileDeliveryNotice({
          lan: this.languageCode,
        }).then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              this.notices = res.data;
            }
          }
        });
    },
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    onClickNotice(notice) {
      const headerId = notice.noticeHeaderId;
      this.$router.push({
        path: "/notice",
        query: {
          noticeHeaderId: headerId,
        },
      });
    },
  },
  watch: {},
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/page/srm/delivery/noticeList.vue